import React from "react";
import { Col, Row, Badge } from "react-bootstrap";
import { object } from "prop-types";
import NumberedScoreScale from "components/DynamicScoreReportScales/NumberedScoreScale";
import { scaleTraitFieldToPretty } from "components/DynamicScoreReportScales/constants";
import { CPILowAndHighBarText } from "../../constants";

const CPI = ({ reportText, testScores }) => {
  const CPI_TRAITS = scaleTraitFieldToPretty[13];

  // ---------------------------- Results Snapshot ----------------------------
  const getResultsSnapshot = () => {
    if (!reportText.get("translatedSnapshots")) {
      return "";
    }
    return (
      <div>
        <h3 className="reportHeader mt-4">Results Snapshot</h3>
        <ul className="double-list">
          {reportText.get("translatedSnapshots").map((list, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={i}>{list}</li>
          ))}
        </ul>
        <hr className="divider mt-4 mb-4" />
      </div>
    );
  };

  // ---------------------------- Score Details ----------------------------
  const getScoreDetails = () => {
    const allDetails = Object.entries(CPI_TRAITS).map(
      ([traitAbbrev, traitName]) => (
        <tr key={traitAbbrev}>
          <td>{getScoreDetailsIcon(traitName)}</td>
          <td>
            <strong style={{ fontSize: "13px", margin: "0 8px" }}>
              {traitName}
            </strong>
          </td>
          <td>
            <span className="pole-text">
              {CPILowAndHighBarText[traitAbbrev].lowPole}
            </span>
          </td>
          <td style={{ display: "flex", marginTop: "10%" }}>
            <NumberedScoreScale
              score={testScores.get(traitAbbrev)}
              maxScore={100}
              cellSpan={10}
              hideNumbers
            />
          </td>
          <td>
            <span className="pole-text">
              {CPILowAndHighBarText[traitAbbrev].highPole}
            </span>
          </td>
        </tr>
      )
    );

    return (
      <div>
        <h3 className="reportHeader">Score Details</h3>
        <table className="w-100">
          <colgroup>
            <col span="1" />
            <col span="1" style={{ width: "15%" }} />
            <col span="1" />
            <col span="1" style={{ width: "55%" }} />
            <col span="1" />
          </colgroup>
          <tbody>{allDetails}</tbody>
        </table>
        <hr className="divider mt-4 mb-4" />
      </div>
    );
  };

  const getScoreDetailsIcon = (traitName) => {
    try {
      const parsedName = (traitName || "").replaceAll(" ", "-").toLowerCase();
      // eslint-disable-next-line global-require
      const imgSrc = require(
        `resources/images/dynamic_score_reports/personality/score-report/${parsedName}-icon.png`
      );

      return <img src={imgSrc} alt={traitName} width="64" height="64" />;
    } catch (error) {
      return "";
    }
  };

  // ---------------------------- Descriptions Details ----------------------------
  const getDescriptionDetails = () => {
    const descriptions = [];
    Object.entries(CPI_TRAITS).forEach(([traitAbbrev, traitName]) => {
      const traitKey = `${traitAbbrev}_text`;
      if (!reportText.get(traitKey)) {
        return;
      }

      descriptions.push(
        <Col lg={6} key={traitAbbrev}>
          <Row className="m-2 align-items-center">
            {getScoreDetailsIcon(traitName)}
            <h5 className="sr-h5 ml-2">{traitName}</h5>
          </Row>
          <div
            key={traitAbbrev}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: reportText.get(traitKey),
            }}
          />
        </Col>
      );
    });

    return (
      <div>
        <div style={{ display: "flex", flexWrap: "wrap" }}>{descriptions}</div>
        <hr className="divider mt-4 mb-4" />
      </div>
    );
  };

  // ---------------------------- Interview Guide ----------------------------
  const getInterviewGuide = () => {
    if (!reportText.get("questions")) {
      return "";
    }
    const InterviewQuestionSections = [];

    reportText.get("questions").forEach((questionData, questionTrait) => {
      const mapData = questionData.first();
      const questionListItems = mapData
        .get("questions")
        .map((question, idx) => <li key={idx}>{question}</li>); // eslint-disable-line react/no-array-index-key

      InterviewQuestionSections.push(
        // eslint-disable-next-line react/no-array-index-key
        <div key={questionTrait}>
          <Badge className="badge-interview">{questionTrait}</Badge>
          <div className="font-weight-bold">{mapData.get("prompt")}</div>
          <ol className="mt-2">{questionListItems}</ol>
        </div>
      );
    });

    return (
      <div>
        <h3 className="reportHeader mb-3">Interview Guide</h3>
        <div>{InterviewQuestionSections}</div>
      </div>
    );
  };

  return reportText ? (
    <div>
      {getResultsSnapshot()}
      {getScoreDetails()}
      {getDescriptionDetails()}
      {getInterviewGuide()}
    </div>
  ) : null;
};

CPI.propTypes = {
  reportText: object,
  testScores: object,
};

export default CPI;
